// extracted by mini-css-extract-plugin
export var cmtNavMegaItem = "styles-module--cmt-nav-mega-item--8cd83";
export var cmtNavMegaItem__description = "styles-module--cmt-nav-mega-item__description--83cd5";
export var cmtNavMegaItem__link = "styles-module--cmt-nav-mega-item__link--70ddf";
export var cmtNavMegaItem__title = "styles-module--cmt-nav-mega-item__title--55284";